import { take, put } from "redux-saga/effects";
import {
  createAssignmentActions,
  UPDATE_FIRST_STEP_ASSIGNMENT,
  updateFirstSectionAssignmentActions
} from "src/redux/actions/assignments";

// services
import { createFirstStepAssignment } from "src/services/http/assignments";

// types
import { CreateFirstSectionAssignmentRequestTypes } from "src/redux/actions/assignments/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchUpdateFirstStepAssignmentRequest() {
  while (true) {
    const { payload }: IActionType<CreateFirstSectionAssignmentRequestTypes> = yield take(
      UPDATE_FIRST_STEP_ASSIGNMENT.REQUEST
    );

    try {
      const id: number = yield call(createFirstStepAssignment, payload);

      console.log("here", payload);
      yield put(updateFirstSectionAssignmentActions.success());

      if (payload.onSuccess) {
        payload.onSuccess(id);
      }
      yield put(updateFirstSectionAssignmentActions.success());
    } catch (e) {
      console.log(e, "error");
      yield put(createAssignmentActions.error(e as any));
    }
  }
}

export default watchUpdateFirstStepAssignmentRequest;
